var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isSelf)?_c('button',{class:_vm.stateClass,attrs:{"aria-label":_vm.isFollowing ? _vm.$t('general.following') : _vm.$t('general.follow')},on:{"click":_vm.toggleFollow}},[(!_vm.isFollowing)?_vm._t("follow"):_vm._t("following")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }